const whitelistKeysUTL = (obj, whitelistedKeys) =>
  Object.assign({}, ...whitelistedKeys.map(key => ({ [key]: obj[key] })));

export default whitelistKeysUTL;
